import { DataBean } from "../DataBean";

export class ProvisionCatalog extends DataBean {

    public async getProvisionCatalog(year: any, idAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProvisionCatalog_Number_Number", [year, idAccount]);
    }

}